import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";
import {TimelineLite} from "gsap";
import {ThorGameMode} from "../../gamemode/ThorGameMode";
import {ThorFSBonusFeaturePlayingController} from "../../reelstoppresentation/fsbonusfeature/ThorFSBonusFeaturePlayingController";
import {ThorParsedGameData} from "../../server/data/ThorParsedGameData";
import {ThorGameModuleConfig} from "../../ThorGameModuleConfig";
import {ThorRandomWildsWPController} from "../randomwilds/ThorRandomWildsWPController";

/**
 * Created by Jerker Nord on 2019-06-26.
 */

export class ThorFSExtraFSWPController extends WinPresentationController {

    private _shouldPlayExtraFS:boolean;
    private _extraFSPlaying:boolean;
    private _FSFeatureSelectEnded:boolean = false;
    private _addNewFSTL:TimelineLite;
    private _FSLeft:number = 0;
    private _FSMjolnirAnimationAborted:boolean = false;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "ThorFSExtraFSWP", skippable : true});
    }

    protected parseFeatureGameData(data:ThorParsedGameData):void {
        this._shouldPlayExtraFS = false;
        this._extraFSPlaying = false;
        this._FSMjolnirAnimationAborted = false;
        this._FSLeft = data.freespinsLeft;
        if((data.mode == ThorGameMode.FREESPIN || data.mode == ThorGameMode.NUDGE_RESPIN_FS) && data.nextMode == ThorGameMode.NUDGE_RESPIN_FS && data.nudgeFeatureRewarded == ThorParsedGameData.NUDGE_REWARDED_EXTRA_FS_SPINS) {
            this._shouldPlayExtraFS = true;
            this._extraFSPlaying = true;
        }
    }

    protected addFeatureEventHandlers():void {
        EventHandler.addEventListener(this, ThorRandomWildsWPController.ICON_SELECT_ANIMATION_COMPLETE, ():void => this.onIconSelectanimationComplete());
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_FEATURE_SELECT_ENDED, ():void => this.onFSFeatureSelectEnded());
        EventHandler.addEventListener(this, ThorFSBonusFeaturePlayingController.FS_MJOLNIR_ANIMATION_ABORTED, ():void => this.onMjolnirAnimationAborted());
    }

    private onMjolnirAnimationAborted():void {
        this._FSMjolnirAnimationAborted = true;
    }

    private onFSFeatureSelectEnded():void {
        if(this._shouldPlayExtraFS == true && this._extraFSPlaying == true) {
            this._FSFeatureSelectEnded = true;
        }
    }

    private onIconSelectanimationComplete():void {
        if(this._shouldPlayExtraFS == true && this._extraFSPlaying == true) {
            if(this._addNewFSTL && this._addNewFSTL.isActive()) {
                this._addNewFSTL.pause();
                this._addNewFSTL.kill();
            }
            this._addNewFSTL = new TimelineLite();
            this._addNewFSTL.add(ThorGameModuleConfig.thorExtraFSIconView.getAwardExtraFSTL(this._FSLeft));
            this._addNewFSTL.add(() => {
                this.finish();
            });
        }
    }

    protected hasWin():boolean {
        return this._shouldPlayExtraFS;
    }

    protected startWinPresentation():void {
        Logger.logDev(`${this.moduleName} startWinPresentation this._shouldPlayExtraFS=${this._shouldPlayExtraFS}, this._extraFSPlaying=${this._extraFSPlaying}, this._FSFeatureSelectEnded=${this._FSFeatureSelectEnded}`)
        if(this._shouldPlayExtraFS == false && this._extraFSPlaying == false) {
            this.finish();
        }
        if(this._FSFeatureSelectEnded == true) {
            this._FSFeatureSelectEnded = false;
            this.onIconSelectanimationComplete();
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted == true) {
            if(this._FSMjolnirAnimationAborted == false) {
                ThorGameModuleConfig.thorMjolnirtimeView.abort();
            }
            if(this._shouldPlayExtraFS == true && this._extraFSPlaying == true) {
                this._extraFSPlaying = false;
                if(this._addNewFSTL && this._addNewFSTL.isActive()) {
                    this._addNewFSTL.pause();
                    this._addNewFSTL.kill();
                }
            }
            ThorGameModuleConfig.thorExtraFSIconView.abort();
            ThorGameModuleConfig.thorExtraFreeSpinsController.abort();
            SlotGame.keypad.setZeroBetSpinCounter(this._FSLeft);
            ThorGameModuleConfig.thorFreeSpinBoxView.updateFSNumber(this._FSLeft);
        }
    }
}